export const RouteDefine = {
    home: "home",
    invoice: "invoice",
    customer: "customer",
    product: "product",
    setupConnection: "setup-connection"
}